import App from './App.svelte';
import * as config from './config';
export default new App({
    target: document.querySelector(config.TARGET_HTML_SELECTOR)
});
